export const mqs = {
  xs: '@media (max-width: 575px)', // Extra small devices (eg: portrait phones, less than 576px)
  s: '@media (min-width: 576px)', // Small devices (eg: landscape phones, 576px and up)
  m: '@media (min-width: 768px)', // Medium devices (eg: tablets, 768px and up)
  l: '@media (min-width: 992px)', // Large devices (eg: desktops, 992px and up)
  xl: '@media (min-width: 1200px)', // Extra large devices (eg: large desktops, 1200px and up)
  xxl: '@media (min-width: 1400px)', // Extra extra large devices (eg: tvs, 1200px and up)
}

export const font = {
  family: "'Rubik', sans-serif",
}

const theme: Theme = {
  mqs,
  colors: {
    primary: '#FFF',
    secondary: '#CCC',
  },
  font,
}

export default theme

export type Theme = {
  mqs: {
    xs: string
    s: string
    m: string
    l: string
    xl: string
    xxl: string
  }
  colors: {
    primary: string
    secondary: string
  }
  font: {
    family: string
  }
}
